import React, { useContext } from "react";
import { Layout } from "antd";

import Sidebar from "../Sidebar/index";

import Topbar from "../Topbar/index";
import { footerText } from "util/config";
import App from "routes/index";

import { useRouteMatch } from "react-router-dom";

import { context } from '../../context';
import { SidebarState } from '../../context/sidebar/sidebarContext';

const { Content, Footer } = Layout;

const MainApp = () => {

  const { state } = useContext(context);
  const { navStyle } = state

  const match = useRouteMatch();
  console.log("useRouteMatch_MAINAPP")
  console.log(match)
  console.log("useRouteMatch_MAINAPP")

  console.log("Desde_MainApp")
  return (
    <Layout className="gx-app-layout">
      <SidebarState>
        <Sidebar />
        <Layout>
          <Topbar />
          <Content style={{ backgroundColor: "#fff" }} className={`gx-layout-content`}>
            <App match={match} />
            {/* <Footer>
            <div className="gx-layout-footer-content">
              {footerText}
            </div>
          </Footer> */}
          </Content>
        </Layout>
      </SidebarState>
    </Layout>
  )
};
export default MainApp;